// extracted by mini-css-extract-plugin
module.exports = {"personalData":"PersonalData_personalData__3eYO8","personalData__img":"PersonalData_personalData__img__1r3vl","tableTitleCell":"PersonalData_tableTitleCell__1oVrf"};